import HomeHealthcareSection from './HomeHealthcareSection';

export default HomeHealthcareSection;
